import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { "msg": String } // upload POST url
  static targets = ["msg"]

  connect() {
    this.element.addEventListener("click", this.disableLink.bind(this))
  }

  disableLink(e) {
    console.log("Disabling the link");
    this.element.classList.add("cursor-wait", "pointer-events-none")
    if (this.hasMsgTarget) {
      this.msgTarget.textContent = this.msgValue;
    } else {
      this.element.textContent = this.msgValue;
    }
  }
}
